import styled from 'styled-components';

import contrastYIQ from '../../utils/contrastYIQ';

const DataTableDiv = styled.div<{ fontSize: number; headerPadding: number; setMaxWidthFirstColumn?: boolean; maxWidthFirstColumn?: number }>`
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .tableWrapper {
        flex: 1;
        min-height: 0;
    }

    table {
        table-layout: fixed;
        font-size: 1em;
        height: 100%;
        width: 100%;
        text-align: center;
        border-collapse: collapse;
        font-size: ${({ fontSize }) => fontSize}%;
        padding: 1px;
        th {
            padding: ${({ headerPadding }) => headerPadding}px 0;
        }
        // This is Firefox and Edge hack. We don't want to expand table header when the height of the table change.
        thead tr {
            height: 1px; // make table row as small as possible, but still respect the text
        }
    }

    .oddDay {
        background-color: rgb(217, 217, 217);
    }

    td.date-label > div.rotate-this-outer {
        width: 3em;
    }

    .rotate-this-outer {
        display: inline-block;
        overflow: hidden;
        width: 1.5em;
    }

    .rotate-heading {
        display: inline-block;
        transform: translate(0, 100%) rotate(-90deg);
        transform-origin: 0 0;
        white-space: nowrap;
    }

    .rotate-heading:after {
        content: '';
        display: block;
        // margin: -1.5em 0 100%;
    }

    .rotate-this,
    .rotate-this-vertical {
        display: inline-block;
        transform: translate(0, 100%) rotate(-90deg);
        transform-origin: 0 0;
        line-height: 1.5em;
        white-space: nowrap;
    }

    .rotate-this:after {
        content: '';
        display: block;
        margin: -1.5em 0 100%;
    }

    .rotate-this-vertical:after {
        content: '';
        display: block;
        margin: -2.5em 0 100%;
    }

    .heading-label > div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .unit-label > div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .heading {
        font-size: 1.1em;
        font-weight: bold;
        text-align: center;
    }

    .bordered {
        border: 1px solid gray;
    }

    .endOfDayRow,
    .endOfGroupRow {
        border-bottom: 1px solid gray;
    }

    .sideBordered {
        border-left: 1px solid gray;
        border-right: 1px solid gray;
    }

    .lastElementInColumn {
        border-right: 1px solid gray;
    }

    .firstColumn {
        overflow: hidden;
        ${({ setMaxWidthFirstColumn, maxWidthFirstColumn }) => (setMaxWidthFirstColumn && maxWidthFirstColumn === 0 ? 'display: none;' : '')}
        ${({ setMaxWidthFirstColumn, maxWidthFirstColumn }) => (setMaxWidthFirstColumn ? `width: ${maxWidthFirstColumn}px;` : '')}
    }
`;

const RootComponent = styled.div`
    position: relative;
    height: 100%;
    width: 100%;
`;

const ThreatCell = styled.td<{ bgColor: string; defaultColour: string }>`
    ${({ bgColor, defaultColour }) =>
        bgColor
            ? `
				background-color: ${bgColor} !important;
				color: ${contrastYIQ(bgColor)} !important;
				border-left: 1px solid ${contrastYIQ(bgColor, 0.2)} !important;
				border-right: 1px solid ${contrastYIQ(bgColor, 0.2)} !important;
				`
            : `color: ${defaultColour}`}
`;

export { DataTableDiv, RootComponent, ThreatCell };
